import rg4js from "raygun4js";

export function isRaygunReportingEnabled() {
  if (import.meta.env.DEV) return false;

  switch (import.meta.env.MODE) {
    case "test":
    case "development":
      return false;
    default:
      return true;
  }
}

/**
 * Sends an error to Raygun for error tracking and monitoring
 * @param error The error to send to Raygun
 */
export function sendToRaygun(error: unknown, options: { tags?: string[]; customData?: Record<string, unknown> } = {}) {
  if (!isRaygunReportingEnabled()) {
    console.warn(error);
    return;
  }
  rg4js("send", { error, ...options });
}
